var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-black",class:[_vm.translations[_vm.status].css, _vm.classes]},[_vm._v("\n    "+_vm._s(_vm.$t("reservations.status." + _vm.status))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }